module.exports = __webpack_public_path__ + "img/CollapseIcon.673736dd.svg";